import Image from "~/components/ui/Image";
import type { NavigationBanner } from "./types";

interface NavigationBannersProps {
  images: NavigationBanner[];
  itemName: string;
}

function NavigationBanners({ images, itemName }: NavigationBannersProps) {
  return (
    <>
      {images.map((image) => (
        <div className="w-full max-w-max h-full">
          <div className="h-full w-full">
            {image.link
              ? (
                <a href={image.link}>
                  <Image
                    loading="lazy"
                    fetchPriority="low"
                    width={345}
                    height={434}
                    alt={`Banner ${itemName}`}
                    src={image.src}
                    className="h-full object-cover w-full"
                  />
                </a>
              )
              : (
                <Image
                  loading="lazy"
                  fetchPriority="low"
                  width={345}
                  height={434}
                  alt={`Banner ${itemName}`}
                  src={image.src}
                  className="h-full object-cover w-full"
                />
              )}
          </div>
        </div>
      ))}
    </>
  );
}

export default NavigationBanners;

